import { createContext, useContext } from 'react';

export const CheckTicketContext = createContext(null);

export function useCheckTicket() {
    return useContext(CheckTicketContext);
}
